function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import "./DashboardGrid.scss";

class DashboardGrid extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getStyle", () => {
      let _this$props = this.props,
          style = _this$props.style,
          cols = _this$props.cols,
          rows = _this$props.rows,
          gap = _this$props.gap,
          areas = _this$props.areas;
      return _extends({}, style, {
        display: "grid",
        gridGap: gap,
        gridTemplateColumns: cols,
        gridTemplateRows: rows,
        gridTemplateAreas: areas
      });
    });
  }

  render() {
    const style = this.getStyle();
    return React.createElement("section", {
      className: "admin-dashboard__grid",
      style: style
    }, this.props.children);
  }

}

_defineProperty(DashboardGrid, "defaultProps", {
  style: {},
  gap: undefined,
  cols: undefined,
  rows: undefined,
  areas: undefined
});

export default DashboardGrid;